import { render, staticRenderFns } from "./AddOrSeeDataProcessingModal.vue?vue&type=template&id=13760a9e&scoped=true"
import script from "./AddOrSeeDataProcessingModal.vue?vue&type=script&lang=js"
export * from "./AddOrSeeDataProcessingModal.vue?vue&type=script&lang=js"
import style0 from "./AddOrSeeDataProcessingModal.vue?vue&type=style&index=0&id=13760a9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13760a9e",
  null
  
)

export default component.exports